<div class="wrap">
  <div class="title">
    <mat-icon aria-hidden="true">star</mat-icon>
    <span>Super Like</span>
  </div>

  <div class="msg">
    <strong>Sorry, you are out of superlikes.</strong>
    Scan here to purchase more.
  </div>

  <mat-divider></mat-divider>

  <div class="qr-area">
    <img class="qr" src="assets/Venmo.jpg" alt="Venmo QR code" />
    <div class="hint">
      Please don't actually venmo me.
    </div>
  </div>

  <div class="actions">
    <a mat-raised-button color="primary" [href]="venmoLink" target="_blank" rel="noopener noreferrer">
      <mat-icon>open_in_new</mat-icon>
      Open Venmo
    </a>
    <button mat-button (click)="close()">Back to swiping</button>
  </div>
</div>

